var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramColorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_13",
    "data-name": 13,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 568 546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 465.88,
    y1: 436.27,
    x2: 94.31,
    y2: 99.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f2203e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#b729a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5342d6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m103.05,0h361.9c49.78,0,90.55,40.77,90.55,90.55v361.9c0,49.78-40.78,90.55-90.55,90.55H103.05c-49.78,0-90.55-40.77-90.55-90.55V90.55C12.5,40.77,53.27,0,103.05,0h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m410.35,271.5c0-69.8-56.56-126.35-126.35-126.35s-126.35,56.56-126.35,126.35,56.55,126.35,126.35,126.35,126.35-56.56,126.35-126.35h0Zm-2.39-143.53c-11.28,0-20.33,9.14-20.33,20.33s9.05,20.34,20.33,20.34,20.33-9.06,20.33-20.34-9.14-20.33-20.33-20.33h0Zm-227.25-29.22h206.57c38.28,0,69.46,31.27,69.46,69.45v206.57c0,38.28-31.18,69.46-69.46,69.46h-206.57c-38.19,0-69.46-31.19-69.46-69.46v-206.57c0-38.19,31.27-69.45,69.46-69.45h0Zm206.57-23.15h-206.57c-50.92,0-92.61,41.69-92.61,92.61v206.57c0,51.01,41.69,92.61,92.61,92.61h206.57c51,0,92.61-41.61,92.61-92.61v-206.57c0-50.92-41.6-92.61-92.61-92.61h0Zm-203.41,195.9c0-55.28,44.85-100.13,100.13-100.13s100.13,44.85,100.13,100.13-44.85,100.12-100.13,100.12-100.13-44.85-100.13-100.12h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramColorIcon);
export default __webpack_public_path__ + "static/media/InstagramColorIcon.79842e36778e8da745aa14d4e2856ad1.svg";
export { ForwardRef as ReactComponent };